import { createContext, useContext } from 'react';

export type Ics202DraftApi = {
  openDraft: (sources?: string[], item?: string) => void;
  disabled: boolean;
  generatingSources: ReadonlySet<string>;
  /** Boxes the open composer will write. Empty once the draft is sent or closed. */
  pendingSources: ReadonlySet<string>;
};

const Ics202DraftContext = createContext<Ics202DraftApi | null>(null);

export const Ics202DraftProvider = Ics202DraftContext.Provider;

export const useIcs202Draft = (): Ics202DraftApi | null =>
  useContext(Ics202DraftContext);
